import { ControlOperationType, RADIO_QUESTIONS } from '@domain/districts';

export const isQuestionRadio = ({ id, type }: { id: string; type?: string }) =>
  type === ControlOperationType.RADIO_BUTTONS || RADIO_QUESTIONS.includes(id);
